module.exports = __webpack_public_path__ + "img/editInsertShape.d12df628.svg";